@keyframes pulsingGlow {
  0%,
  100% {
    box-shadow: 0 0 1px 0px #33ccff, 0 0 1px 1px #33ccff;
  }
  50% {
    box-shadow: 0px 0px 3px 2px #33ccff, 0px 0px 6px 4px #33ccff;
  }
}

.DIGORWrapperButton {
  animation: pulsingGlow 2s 7;
}
